<template>
    <div class="detail-year-avg-one-cost">
        <van-nav-bar
            title="本"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
            @click-right="showFilterPop = true"
        >
            <template #title>
                <img class="nav_title" src="../../../assets/images/leadingCockpit/ben_nav.png">
            </template>
            <template #right>
                <img class="shaixuan" src="../../../assets/images/leadingCockpit/shaixuan.png">
            </template>
        </van-nav-bar>
        <div class="container-wrapper">
            <filterConditions
                :show-filter-pop.sync="showFilterPop"
                :date="date"
                @sureBack="sureBack"
            ></filterConditions>
            <div class="data-box">
                <h2 class="title">
                    单位（元/方）
                </h2>
                <div class="data-item left">
                    <p>
                        本月原材料成本：<span>{{ monthCost }}</span>
                    </p>
                    <p>
                        <a>环比：<span class="n1">{{ ringPerc }}</span></a>
                        <a>同比：<span class="n1">{{ samePerc }}</span></a>
                    </p>
                </div>
                <div class="data-item right">
                    <p>
                        年累原材料成本：<span>{{ yearCost }}</span>
                    </p>
                    <p>
                        同比：<span>{{ yearSamePerc }}</span>
                    </p>
                </div>
            </div>
            <div class="bg-line"></div>
            <div class="charts-panel">
                <div class="title">
                    原材料成本
                </div>
                <div id="charts1" class="charts-box">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import filterConditions from './filterConditions/index';
export default {
    name: 'detail-year-avg-one-cost',
    components: { filterConditions },
    data() {
        return {
            showFilterPop: false,
            filterParams: {},
            date: {
                startDate: '',
                endDate: '',
            },
            monthCost: 0, // 本月原材料成本
            ringPerc: 0, // 环比
            samePerc: 0, // 同比
            yearCost: 0, // 年累原材料成本
            yearSamePerc: 0, // 同比

            yearAvgPrice: 0, // 年度均成本
            prevYearAvgPrice: 0, // 上年年均成本
            totalDataList: [], // 本年每月成本列表
            prevTotalDataList: [], // 去年每月价格列表
        };
    },
    created() {
        // 设置时间默认值 默认当月
        this.date.startDate = this.$route.params.startDate;
        this.date.endDate = this.$route.params.endDate;
        this.filterParams = Object.assign({}, this.date);
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            this.getTotalPrice().then(data => {
                this.yearCost = data.single_volume_cost_year;
                this.yearSamePerc = data.single_volume_cost_lastyear;
                this.monthCost = data.list[data.list.length - 1].single_volume_cost;
                this.ringPerc = data.list[data.list.length - 2].single_volume_cost;
                this.samePerc = data.list_last[data.list.length - 1].single_volume_cost;
                this.totalDataList = data.list;
                this.prevTotalDataList = data.list_last;

                this.yearAvgPrice = data.single_volume_cost_year;
                this.prevYearAvgPrice = data.single_volume_cost_lastyear;
                this.initChart1();
            });
        },
        sureBack(pamams) {
            this.filterParams = pamams;
            this.getData();
        },
        getTotalPrice() {
            const url = '/interfaceApi/report/leadercockpit/cost_data';
            const data = this.filterParams;
            return this.$axios.post(url, data);
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        initChart1() {
            const myChart = this.$echarts.init(document.getElementById('charts1'));
            /** **test**********/
            const legendData = ['本年每月成本', '本年年均成本', '上年每月成本', '上年年均成本'];
            const xdata = [];

            const ydata = [
                {
                    name: '本年每月成本',
                    colors: ['#4EA97E', '#DCC94C'],
                    type: 'solid',
                    symbol: 'emptyCircle',
                    data: [],
                },
                {
                    name: '本年年均成本',
                    colors: ['#D7C84E', '#46A67D'],
                    type: 'dashed',
                    symbol: 'none',
                    data: [],
                },
                {
                    name: '上年每月成本',
                    colors: ['#F57D51', '#F94E4D'],
                    type: 'solid',
                    symbol: 'emptyCircle',
                    data: [],
                },
                {
                    name: '上年年均成本',
                    colors: ['#F57D51', '#F94E4D'],
                    type: 'dashed',
                    symbol: 'none',
                    data: [],
                },
            ];
            this.totalDataList.forEach((item, index) => {
                xdata.push(item.month_dim + '月');
                ydata[0].data.push(item.single_volume_cost); // 本年每月成本
                ydata[1].data.push(this.yearAvgPrice); // 本年年均成本
                ydata[2].data.push(this.prevTotalDataList[index].single_volume_cost); // 上年每月成本
                ydata[3].data.push(this.prevYearAvgPrice); // 上年年均成本
            });
            /** **test**********/
            this.drawLine(myChart, { legendData, xdata, ydata });

        },

        drawLine(myChart, { legendData, xdata, ydata }) {
            const newOption = {
                title: {
                    text: '单位（万方）',
                    textStyle: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 10,
                    },
                },
                animationEasing: 'elasticOut',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        label: {
                            show: true,
                        },
                    },
                },
                legend: {
                    width: 173,
                    right: 15,
                    itemWidth: 12,
                    itemHeight: 10,
                    data: legendData,
                    textStyle: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 10,
                    },
                },
                grid: {
                    left: 40,
                    top: 50,
                    right: 10,
                    bottom: 20,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    data: xdata,
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                        //	margin:15,
                        textStyle: {
                            color: 'rgba(255,255,255,0.5)',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 10,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        // 坐标轴轴线相关设置
                        lineStyle: {
                            color: '#D8D8D8',
                            opacity: 0.3,
                        },
                    },
                },
                yAxis: [
                    {
                        axisLabel: {
                            // 坐标轴刻度标签的相关设置。
                            interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                            //	margin:15,
                            textStyle: {
                                color: 'rgba(255,255,255,0.5)',
                                fontStyle: 'normal',
                                fontFamily: '微软雅黑',
                                fontSize: 10,
                            },
                        },
                        axisTick: {
                            // 坐标轴刻度相关设置。
                            show: false,
                        },
                        axisLine: {
                            // 坐标轴轴线相关设置
                            lineStyle: {
                                color: '#D8D8D8',
                                opacity: 0.3,
                            },
                        },
                        splitLine: {
                            // 坐标轴在 grid 区域中的分隔线。
                            show: true,
                            lineStyle: {
                                color: '#fff',
                                opacity: 0.1,
                                type: 'dashed',
                            },
                        },
                    },
                ],
                series: [],
            };
            ydata.forEach(item => {
                newOption.series.push(
                    {
                        name: item.name,
                        type: 'line',
                        symbol: item.symbol,
                        barMaxWidth: 15,
                        silent: true,
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: item.colors[0] },
                                        { offset: 1, color: item.colors[1] },
                                    ]
                                ),
                                label: {
                                    show: false,
                                    position: 'top',
                                    textStyle: {
                                        color: '#DCC229',
                                        fontSize: 10,
                                    },
                                },
                            },
                        },
                        lineStyle: {
                            type: item.type,
                            width: (() => {
                                if (item.type === 'dashed') {
                                    return 1;
                                }
                                return 2;
                            })(),
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    { offset: 0, color: item.colors[0] },
                                    { offset: 1, color: item.colors[1] },
                                ],
                            },
                            opacity: (() => {
                                if (item.type === 'dashed') {
                                    return 0;
                                }
                                return 0.1;
                            })(),
                        },
                        z: 1,
                        animationEasing: 'elasticOut',
                        data: item.data,
                    }
                );
            });
            myChart.setOption(newOption, true );
        },

        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 跳转页面
        to(path) {
            this.$router.isBack = 2;
            this.$router.push({ name: path });
        },
    },
};
</script>
<style scoped lang="stylus">
$bgLineLeft = url("../../../assets/images/leadingCockpit/frame_blue_left.png") left no-repeat
$bgLineRight = url("../../../assets/images/leadingCockpit/frame_blue_right.png") right no-repeat
$bgLineOrangeLeft = url("../../../assets/images/leadingCockpit/frame_orange_left.png") left no-repeat
$bgLineOrangeRight = url("../../../assets/images/leadingCockpit/frame_orange_right.png") right no-repeat
    .detail-year-avg-one-cost
        background url('../../../assets/images/leadingCockpit/bg.png') #0E1C31
        background-size 100%
        padding-bottom 30rpx;
        .van-nav-bar
            background #001F4C!important;
            .shaixuan
                width 18rpx;
        .nav_title
            margin-top 10rpx
            width 52rpx;
        .container-wrapper
            height calc(100% - 20rpx)
            overflow-y auto
        .bg-line
            height 15rpx;
            background rgba(0,0,0,0.5);
        .filterConditions
            display flex
            width 94%;
            height 40rpx
            padding 15rpx 10rpx
            margin: 13rpx auto 0;
            background url("../../../assets/images/leadingCockpit/bg_secondary_page_1.png") no-repeat center
            background-size 100%
            justify-content center
            align-items center
            .line
                width: 20rpx;
                height: 2px;
                background: rgba(255, 255, 255, 0.2);
            .time
                width 80rpx
                height 30rpx
                line-height 28rpx
                margin 0 5rpx
                position relative
                input
                    width 130rpx
                    height 30rpx
                    border none
                    text-indent 30rpx
                    background: transparent;
                    font-size 14rpx;
                    color:#fff;
                    font-family: Technology-Regular, Technology;
                &:before
                    line-height 30rpx
                    font-size 16rpx
                    color #0096F8
                    position absolute
                    left 5rpx
        .data-box
            display flex
            flex-wrap wrap
            justify-content space-between
            padding 15rpx;
            .title
                width 100%;
                font-size 12rpx;
                color #fff;
                padding 15rpx 6rpx;
            .data-item
                font-size 12rpx;
                color #fff;
                width: 165rpx;
                height: 84rpx;
                background: #12243D;
                border: 1px solid #27436C;
                span
                    font-size: 18px;
                    font-family: Technology-Regular, Technology;
                    color: #03B0FE;
                &.left
                    p
                        height 50%;
                        display flex
                        align-items center
                        padding-left 12rpx;
                        font-size 12rpx;
                        color #fff;
                        &:nth-child(1)
                            border-bottom 1px dashed #27436C
                        &:nth-child(2)
                            display flex
                            justify-content space-around
                            span
                                color #6DD400
                        .n1
                            color #FF2F2F
                &.right
                    p
                        height 50%;
                        display flex
                        align-items center
                        padding-left 12rpx;
                        &:nth-child(1)
                            border-bottom 1px dashed #27436C
                            span
                                color #FDDC24
        .charts-panel
            padding 15rpx;
            .title
                font-size 16rpx;
                color:#fff;
            .charts-box
                padding-top 20rpx;
                height 180rpx;
</style>
